window.MN_YARN_PROJECTS = {

  circularProject: {
    name: 'Circular Project',
    image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Circular-Project.png?v=1779240693',
    recommendationUrl: '/pages/yarn-recommendations-by-project',
    activeFields: ['D'],
    displayOrder: ['D'],
    resultNotes: 'Add extra yarn for borders or decorative edging.',

    fields: {
      D: {
        label: 'Diameter',
        helper: 'Measure full diameter across the project',
        placeholder: 'e.g. 20'
      }
    },

    calculateArea: function(values) {
      return (22 / 7) * ((values.D / 2) * (values.D / 2));
    }
  },

  squareProject: {
    name: 'Square Project',
    image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Square-Project.png?v=1779240698',
    recommendationUrl: '/pages/yarn-recommendations-by-project',
    activeFields: ['L'],
    displayOrder: ['L'],
    resultNotes: 'Add extra yarn for decorative borders if required.',

    fields: {
      L: {
        label: 'Length',
        helper: 'Measure one side of the square',
        placeholder: 'e.g. 18'
      }
    },

    calculateArea: function(values) {
      return values.L * values.L;
    }
  },

  rectangularProject: {
    name: 'Rectangular Project',
    image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Rectangular-Project.png?v=1779240706',
    recommendationUrl: '/pages/yarn-recommendations-by-project#rectangular-project',
    activeFields: ['L', 'W'],
    displayOrder: ['L', 'W'],
    resultNotes: 'Add extra yarn for decorative edging if required.',

    fields: {
      L: {
        label: 'Length',
        helper: 'Measure full length',
        placeholder: 'e.g. 50'
      },

      W: {
        label: 'Width',
        helper: 'Measure full width',
        placeholder: 'e.g. 30'
      }
    },

    calculateArea: function(values) {
      return values.L * values.W;
    }
  },

  triangularProject: {
    name: 'Triangular Project',
    image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Triangular-Project.png?v=1779240711',
    recommendationUrl: '/pages/yarn-recommendations-by-project#triangular-project',
    activeFields: ['W', 'H'],
    displayOrder: ['W', 'H'],
    resultNotes: 'Add extra yarn for tassels or decorative edging.',

    fields: {

      W: {
        label: 'Base Width',
        helper: 'Measure the base width',
        placeholder: 'e.g. 24'
      },

      H: {
        label: 'Height',
        helper: 'Measure vertical height',
        placeholder: 'e.g. 18'
      }
    },

    calculateArea: function(values) {
        return (values.W * values.H) / 2;
    }
  },

  sweater: {
    name: 'Pullover, Tops etc.',
    image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Sweater-Project.png?v=1779240683',
    recommendationUrl: '/pages/yarn-recommendations-by-project#sweater',
    activeFields: ['S', 'L', 'AH', 'SL'],
    displayOrder: ['S', 'L', 'AH', 'SL'],
    resultNotes: 'Add extra yarn for ribbing or oversized fits.',

    fields: {

      S: {
        label: 'Shoulder Width',
        helper: 'Measure shoulder width flat',
        placeholder: 'e.g. 18'
      },

      L: {
        label: 'Body Length',
        helper: 'Measure from shoulder to bottom hem',
        placeholder: 'e.g. 24'
      },

      AH: {
        label: 'Armhole Circumference',
        helper: 'Measure around the armhole',
        placeholder: 'e.g. 18'
      },

      SL: {
        label: 'Sleeve Length',
        helper: 'Measure shoulder to sleeve end',
        placeholder: 'e.g. 22'
      }
    },

    calculateArea: function(values) {
      return (values.S * values.L * 2) +
             (values.AH * values.SL * 2);
    }
  },

  jacket: {
  name: 'Jackets, Shirts, Shrugs etc.',
  image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Front-Open-Sweater-Project.png?v=1779519775',
  recommendationUrl: '/pages/yarn-recommendations-by-project#jacket',
  activeFields: ['S', 'L', 'AH', 'SL', 'W'],
  displayOrder: ['S', 'L', 'AH', 'SL', 'W'],
  resultNotes: 'Add extra yarn for a hoodie, collar, pocket, or border.',

  fields: {

    S: {
      label: 'Shoulder Width',
      helper: 'Measure shoulder width flat',
      placeholder: 'e.g. 18'
    },

    L: {
      label: 'Body Length',
      helper: 'Measure from shoulder to bottom hem',
      placeholder: 'e.g. 28'
    },

    AH: {
      label: 'Armhole Circumference',
      helper: 'Measure around the armhole',
      placeholder: 'e.g. 18'
    },

    SL: {
      label: 'Sleeve Length',
      helper: 'Measure shoulder to sleeve end',
      placeholder: 'e.g. 22'
    },

    W: {
      label: 'Front Panel Width',
      helper: 'Measure width of one front panel',
      placeholder: 'e.g. 10'
    }
  },

  calculateArea: function(values) {
    return (values.S * values.L) +
           (values.AH * values.SL * 2) +
           (values.W * 2 * values.L);
  }
},

  skirt: {
  name: 'Skirt',
  image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Skirt-Project.png?v=1779240662',
  recommendationUrl: '/pages/yarn-recommendations-by-project#skirt',
  activeFields: ['L', 'C', 'C1'],
  displayOrder: ['L', 'C', 'C1'],
  resultNotes: 'Add extra yarn for borders or flare.',

  fields: {

    L: {
      label: 'Skirt Length',
      helper: 'Measure from waist to bottom hem',
      placeholder: 'e.g. 30'
    },

    C: {
      label: 'Waist Circumference',
      helper: 'Measure around the waist',
      placeholder: 'e.g. 30'
    },

    C1: {
      label: 'Bottom Flare Circumference',
      helper: 'Measure around the bottom flare',
      placeholder: 'e.g. 60'
    }
  },

  calculateArea: function(values) {
    return ((values.C * values.L) / 2) +
           ((values.C1 * values.L) / 2);
  }
},

  dress: {
  name: 'Dress',
  image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Dress-project.png?v=1779240665',
  recommendationUrl: '/pages/yarn-recommendations-by-project#dress',
  activeFields: ['S', 'L', 'AH', 'SL', 'W', 'C1'],
  displayOrder: ['S', 'L', 'AH', 'SL', 'W', 'C1'],
  resultNotes: 'Add extra yarn for flare or decorative edging.',

  fields: {

    S: {
      label: 'Shoulder Width',
      helper: 'Measure shoulder width flat',
      placeholder: 'e.g. 15'
    },

    L: {
      label: 'Dress Length',
      helper: 'Measure from shoulder to hem',
      placeholder: 'e.g. 40'
    },

    AH: {
      label: 'Armhole Circumference',
      helper: 'Measure around the armhole',
      placeholder: 'e.g. 18'
    },

    W: {
      label: 'Waist',
      helper: 'Measure around waist',
      placeholder: 'e.g. 30'
    },

    C1: {
      label: 'Flare Circumference',
      helper: 'Measure around the bottom flare',
      placeholder: 'e.g. 60'
    },

    SL: {
      label: 'Sleeve Length',
      helper: 'Measure shoulder to sleeve end',
      placeholder: 'e.g. 10'
    }
  },

  calculateArea: function(values) {
    return ((values.S * values.L) / 4) +
           ((values.W * values.L) / 4) +
           ((values.C1 * values.L) / 2) +
           (values.AH * values.SL * 2);
  }
},

  cap: {
    name: 'Beanie',
    image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Beanie-Project.png?v=1779240701',
    recommendationUrl: '/pages/yarn-recommendations-by-project#cap',
    activeFields: ['C', 'H'],
    displayOrder: ['C', 'H'],
    resultNotes: 'Add extra yarn for pom-poms, folded brim, braids etc.',

    fields: {

      C: {
        label: 'Head Circumference',
        helper: 'Measure around the head',
        placeholder: 'e.g. 23'
      },

      H: {
        label: 'Cap Height',
        helper: 'Measure from crown to brim',
        placeholder: 'e.g. 10'
      }
    },

    calculateArea: function(values) {
      return values.C * values.H;
    }
  },

  bag: {
    name: 'Bag',
    image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Bag-Project.png?v=1779240674',
    recommendationUrl: '/pages/yarn-recommendations-by-project#bag',
activeFields: ['L', 'W', 'DP', 'L3', 'W2', 'N'],
displayOrder: ['L', 'W', 'DP', 'L3', 'W2', 'N'],
    resultNotes: 'Estimate excludes lining, zipper, and accessories.',

    fields: {

      L: {
        label: 'Bag Width',
        helper: 'Measure side to side',
        placeholder: 'e.g. 14'
      },

      W: {
        label: 'Bag Height',
        helper: 'Measure top to bottom',
        placeholder: 'e.g. 12'
      },

      DP: {
        label: 'Bag Depth',
        helper: 'Measure side depth',
        placeholder: 'e.g. 4'
      },

      L3: {
        label: 'Handle Length',
        helper: 'Measure full handle length',
        placeholder: 'e.g. 20'
      },

      W2: {
        label: 'Handle Width',
        helper: 'Measure handle width',
        placeholder: 'e.g. 1.5'
      },

      N: {
        label: 'Number of Handles',
        helper: 'Enter total number of handles',
        placeholder: 'e.g. 2'
      }
    },

calculateArea: function(values) {
  return (values.L3 * values.W2 * values.N) +
         (values.L * values.W * 2) +
         ((values.L + values.L + values.W) * values.DP);
}
  },

  shorts: {
    name: 'Shorts',
    image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Shorts-Project.png?v=1779240678',
    recommendationUrl: '/pages/yarn-recommendations-by-project#shorts',
    activeFields: ['C', 'C1', 'L'],
    displayOrder: ['C', 'C1', 'L'],
    resultNotes: 'Add extra yarn for waistband or pockets.',

    fields: {

      C: {
        label: 'Waist Circumference',
        helper: 'Measure around waist',
        placeholder: 'e.g. 40'
      },

      C1: {
        label: 'Thigh Circumference',
        helper: 'Measure around leg opening',
        placeholder: 'e.g. 14'
      },

      L: {
        label: 'Length',
        helper: 'Measure waist to hem',
        placeholder: 'e.g. 20'
      }
    },

calculateArea: function(values) {
  return ((values.C * values.L) / 2) +
         (((values.L / 2) * values.C1 * 2));
}
  },

  scarfMuffler: {
    name: 'Scarf / Muffler',
    image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Scarf-Project.png?v=1779240924',
    recommendationUrl: '/pages/yarn-recommendations-by-project#scarf',
    activeFields: ['L', 'W'],
    displayOrder: ['L', 'W'],
    resultNotes: 'Add extra yarn if adding tassels or fringe.',

    fields: {

      L: {
        label: 'Length',
        helper: 'Measure from one end to the other, excluding tassels',
        placeholder: 'e.g. 70'
      },

      W: {
        label: 'Width',
        helper: 'Measure width flat',
        placeholder: 'e.g. 10'
      }
    },

    calculateArea: function(values) {
      return values.L * values.W;
    }
  },

  socks: {
    name: 'Socks (Pair)',
    image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Socks-Project.png?v=1779240716',
    recommendationUrl: '/pages/yarn-recommendations-by-project#socks',
    activeFields: ['L', 'L1', 'C', 'C1'],
    displayOrder: ['L', 'L1', 'C', 'C1'],
    resultNotes: 'Add extra yarn for ribbing or longer sock height.',

    fields: {

      L: {
        label: 'Foot Length',
        helper: 'Measure heel to toe',
        placeholder: 'e.g. 8'
      },

      L1: {
        label: 'Sock Height',
        helper: 'Measure from heel upward',
        placeholder: 'e.g. 8'
      },

      C: {
        label: 'Foot Circumference',
        helper: 'Measure around foot',
        placeholder: 'e.g. 7'
      },

      C1: {
        label: 'Calf Circumference',
        helper: 'Measure around calf',
        placeholder: 'e.g. 15'
      }
    },

calculateArea: function(values) {
  return (
    (values.L * values.C) +
    (values.L1 * values.C1)
  ) * 2;
}
  },

  mittens: {
    name: 'Fingerless Mittens (Pair)',
    image: 'https://cdn.shopify.com/s/files/1/0618/4642/1754/files/Fingerless-Mittens-Project.png?v=1779240670',
    recommendationUrl: '/pages/yarn-recommendations-by-project#mittens',
    activeFields: ['L', 'C'],
    displayOrder: ['L', 'C'],
    resultNotes: 'Add extra yarn for cuffs or thumb shaping.',

    fields: {

      L: {
        label: 'Mitten Length',
        helper: 'Measure from one end to the other',
        placeholder: 'e.g. 8'
      },

      C: {
        label: 'Mitten Circumference',
        helper: 'Measure around the palm, including the thumb',
        placeholder: 'e.g. 8'
      },

    },

calculateArea: function(values) {
  return (
    (values.L * values.C)
  ) * 2;
}
  }

};

(function () {

  const PROJECTS = window.MN_YARN_PROJECTS || {};

  const projectSelect = document.getElementById('project-select');
  const fieldsWrap = document.getElementById('dynamic-fields');
  const resultCard = document.getElementById('result-card');
  const estimatedYarn = document.getElementById('estimated-yarn');
  const recommendedQuantity = document.getElementById('recommended-quantity');
  const recommendationLink = document.getElementById('recommendation-link');
  const resultNote = document.getElementById('result-note');
  const projectImageWrap = document.getElementById('project-image-wrap');
  const projectImage = document.getElementById('project-image');

  Object.entries(PROJECTS).forEach(function([key, project]) {

    const option = document.createElement('option');

    option.value = key;
    option.textContent = project.name;

    projectSelect.appendChild(option);

  });

  projectSelect.addEventListener('change', function() {
    renderProject(projectSelect.value);
  });

  function renderProject(projectKey) {

    fieldsWrap.innerHTML = '';

    resultCard.style.display = 'none';

    if (!projectKey || !PROJECTS[projectKey]) {

      projectImageWrap.style.display = 'none';

      return;
    }

    const project = PROJECTS[projectKey];

    projectImage.src = project.image;

    projectImageWrap.style.display = 'block';

    recommendationLink.href = project.recommendationUrl;

    resultNote.textContent = project.resultNotes || '';

    const unitNote = document.createElement('div');
    
    unitNote.className = 'mn-unit-note';

    unitNote.innerHTML = 'Enter all measurements in inches.';

    fieldsWrap.appendChild(unitNote);

    project.displayOrder.forEach(function(fieldKey) {

      const field = project.fields[fieldKey];

      const fieldWrap = document.createElement('div');

      fieldWrap.className = 'mn-field-group';

      fieldWrap.innerHTML = `
        <label>${field.label}</label>

        <input
          type="number"
          inputmode="decimal"
          step="any"
          placeholder="${field.placeholder}"
          data-field="${fieldKey}"
        >

        <div class="mn-helper-text">
          ${field.helper}
        </div>
      `;

      fieldsWrap.appendChild(fieldWrap);

    });

    const inputs = fieldsWrap.querySelectorAll('input');

    inputs.forEach(function(input) {

      input.addEventListener('input', function() {
        calculate(projectKey);
      });

    });

  }

  function calculate(projectKey) {

    const project = PROJECTS[projectKey];

    const values = {};

    let hasValue = false;

    project.activeFields.forEach(function(fieldKey) {

      const input = fieldsWrap.querySelector(
        `[data-field="${fieldKey}"]`
      );

      values[fieldKey] = parseFloat(input.value) || 0;

      if (values[fieldKey] > 0) {
        hasValue = true;
      }

    });

    if (!hasValue) {

      resultCard.style.display = 'none';

      return;
    }

    const area = project.calculateArea(values);

    const calculatedYarn = (area / 225) * 100;

    const roundedYarn = Math.ceil(calculatedYarn / 50) * 50;

    const skeins = Math.ceil(roundedYarn / 100);

    estimatedYarn.textContent = `${roundedYarn}g`;

    recommendedQuantity.textContent =
      `${skeins} × 100g skeins`;

    resultCard.style.display = 'block';

  }

})();